export const getCategoryPageLink = (category, variant = "healthcare") => {
  const base = variant === "community" ? "/category2" : "/category";
  return `${base}?category=${encodeURIComponent(category)}`;
};

export const isPdfPath = (url) =>
  typeof url === "string" && url.toLowerCase().includes(".pdf");

export const buildAttachmentDocuments = (ad, attachments = []) => {
  const documents = [];

  if (ad?.type && isPdfPath(ad.type)) {
    documents.push({ url: ad.type });
  }

  attachments.forEach((attachment) => {
    if (attachment?.attachmentUrl) {
      documents.push({ url: attachment.attachmentUrl });
    }
  });

  return documents;
};

export const hasPdfAttachments = (item) => {
  const hasTableAttachments =
    Array.isArray(item?.attachments) && item.attachments.length > 0;
  const hasLegacyType = item?.type && isPdfPath(item.type);
  return hasTableAttachments || hasLegacyType;
};

export const getAttachmentViewerPath = (adId, variant = "healthcare") => {
  const base = variant === "community" ? "/userAttachment2" : "/userAttachment";
  return `${base}?adId=${adId}`;
};

export const mergeAdsWithAttachments = (ads = [], allAttachments = []) => {
  return ads.map((ad) => ({
    ...ad,
    attachments: allAttachments.filter(
      (attachment) => Number(attachment.adId) === Number(ad.id),
    ),
  }));
};
